<template>
    <div>
        <div
            class="pc-nav-menu position-relative"
            v-bind:class="{ 'menu-expanded': expandSubmenu }">
            <component
                v-bind:is="hasSubItems ? 'button' : 'a'"
                v-bind:href="headerUrl"
                class="pc-nav-main-icon text-white"
                v-bind:data-pc-menu-name="navMenu.MenuTypeName"
                v-bind:class="headerClassObj"
                v-on="listeners">
                <navIcon
                    v-bind:menu-type-name="navMenu.MenuTypeName"
                    v-bind:class="iconClassObj" />
                {{ navMenu.Text }}
            </component>
            <template v-if="sidebarExpanded">
                <pc-transition
                    transition="slide"
                    v-on:after-enter="afterEnter">
                    <div v-show="expandSubmenu">
                        <a
                            v-for="item in navMenu.NavMenuItems"
                            v-bind:key="item.Text"
                            v-bind:ref="item.PageTypeName"
                            v-bind:href="getItemUrl(item.Url)"
                            v-bind:data-pc-page-name="item.PageTypeName"
                            class="pc-nav-item text-white d-flex ps-3 py-2">
                            <navIcon
                                v-bind:page-name="item.PageTypeName"
                                class="me-3" />
                            {{ item.Text }}
                        </a>
                    </div>
                </pc-transition>
            </template>
        </div>
        <nav-float-menu
            v-if="hasSubItems"
            ref="navFloatMenu"
            v-bind:nav-menu="navMenu"
            v-on:popper-opened="onShowPopper"
            v-on:popper-closed="onClosePopper" />
    </div>
</template>

<script>
    import navIcon from "./navIcon.vue";
    import navFloatMenu from "./navFloatMenu.vue";

    export default {
        components: { navIcon, navFloatMenu },
        props: {
            navMenu: { type: Object, required: true },
            sidebarExpanded: { type: Boolean, required: true }
        },
        emits: ["menu-clicked", "show-float-popper", "page-transition-end"],
        data() {
            return {
                expandSubmenu: false
            };
        },
        computed: {
            headerUrl() {
                return `${this.navMenu.Url}?ProgramId=${this.$app.ProgramId}`;
            },
            listeners() {
                if (!this.hasSubItems) {
                    return {};
                }
                return {
                    click: this.menuClicked
                };
            },
            hasSubItems() {
                return this.navMenu.NavMenuItems && this.navMenu.NavMenuItems.length > 0;
            },
            headerClassObj() {
                if (this.sidebarExpanded) {
                    return ["d-flex", "p-3", "align-items-center"];
                }
                return ["d-flex", "flex-column", "align-items-center", "p-3", "text-center"];
            },
            iconClassObj() {
                return {
                    "me-3": this.sidebarExpanded,
                    "mb-2": !this.sidebarExpanded
                };
            }
        },
        watch: {
            sidebarExpanded() {
                this.expandSubmenu = false;
            }
        },
        methods: {
            getItemUrl(url) {
                return `${url}?ProgramId=${this.$app.ProgramId}`;
            },
            menuClicked() {
                if (!this.hasSubItems) {
                    return;
                }
                if (!this.sidebarExpanded) {
                    this.$refs.navFloatMenu.popper_toggle(this.$el);
                    return;
                }
                this.$emit("menu-clicked", this.navMenu.MenuTypeName);
                this.expandSubmenu = !this.expandSubmenu;
            },
            close() {
                this.expandSubmenu = false;
            },
            // runs after the transition group - the navigational menu - has fully expanded
            // emits an event to the sidebar letting it know that the menu has fully opened
            // so we can display a popper if necessary
            afterEnter() {
                this.$emit("page-transition-end", this.navMenu.MenuTypeName);
            },
            // upon showing a float menu, emit an event to the sidebar to let it know we are showing a float menu
            // so we can show any relevant poppers
            onShowPopper() {
                this.expandSubmenu = true;
                this.$emit("show-float-popper", { menuType: this.navMenu.MenuTypeName, isShown: true });
            },
            // upon closing a float menu, emit an event to the sidebar to let it know we are closing a float menu
            // i.e. we must close any poppers associated with the float menu
            onClosePopper() {
                this.expandSubmenu = false;
                this.$emit("show-float-popper", { menuType: this.navMenu.MenuTypeName, isShown: false });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "./_nav-style-vars.scss";

    .pc-nav-menu {
        cursor: pointer;
        &:hover,
        &.menu-expanded {
            background-color: $pc-nav-lvl1-color;
        }
    }

    .pc-nav-main-icon {
        text-decoration: none;
        background-color: transparent;
        display: block;
        width: 100%;
        border: none;
    }

    .pc-nav-item {
        text-transform: none;
        text-decoration: none;
        &:hover {
            background-color: $pc-nav-lvl2-color;
        }
    }
</style>
